import { Article } from "../types/articles";
import { OrderModalOpenEvent } from "../types/app-shell-events";

export function publishToOrderModal(
  article: Article,
  itemOrigin: string,
  productRecoModel: string,
  pageLocation: string
): void {
  const eventData: OrderModalOpenEvent = {
    colorCode: article.colorCode,
    itemOrigin: itemOrigin,
    masterArticleNo: article.masterArticleNo,
    salesArticleNo: article.salesArticleNo,
    sizeCode: article.sizeCode,
    semanticId: "product-recommendation-tile",
    productRecommendationTileIndex: article.slot,
    productRecommendationFragment: `product-recommendation-${pageLocation}`,
    productRecommendationModel: productRecoModel
  };

  shell?.messageBroker.publishTo("ESPP.OrderModal.Open", eventData);
}
